import React, { useState, useRef } from 'react';
import { FaFileExcel, FaFilePdf, FaTimes, FaNewspaper, FaDownload } from 'react-icons/fa';
import { validateEmail } from '../../utils/mail';
import { fetchClientNewsletterPreview } from '../../services/api/fetchClient';
import { sendNewsletterWithClippings } from '../../services/api/fetchNewsletter';
import { fetchReport } from '../../services/api/fetchClipping';
import ReactLoading from 'react-loading';
import './ModalExport.css';
import Select from 'react-select';
import RelatorioAnalitico from '../Reports/AnaliticoTemplate/RelatorioAnalitico';
import { postAnalyticalReportDataByClippingIds } from '../../services/api/fetchAnalyticalReportData';
import { getAnalyticalReportDataDetails } from '../../services/api/fetchAnalyticalReportData';
import RelatorioStatusCard from '../RelatorioStatusCard/RelatorioStatusCard';
import { patchAnalyticalReportData } from '../../services/api/fetchAnalyticalReportData';

export function ExportModal({ onClose, onExportExcel, onExportPDF, selectedCards, clientId }) {
  const [showEmailInput, setShowEmailInput] = useState(false);
  const [showPdfInput, setShowPdfInput] = useState(false);
  const [email, setEmail] = useState('');
  const [pdfTitle, setPdfTitle] = useState('');
  const [pdfSubtitle, setPdfSubtitle] = useState('');
  const [sortOption, setSortOption] = useState('veiculo');
  const [includeTitleAndSubtitle, setIncludeTitleAndSubtitle] = useState(true);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [includeSummary, setIncludeSummary] = useState(true);
  const [showNewsletterInput, setShowNewsletterInput] = useState(false);
  const [newsletterEmail, setNewsletterEmail] = useState('');
  const [newsletterId, setNewsletterId] = useState(null);
  const [iframeUrl, setIframeUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [template, setTemplate] = useState('');
  const [logoPosition, setLogoPosition] = useState('default');
  const [titleFontSize, setTitleFontSize] = useState(14);
  const [subtitleFontSize, setSubtitleFontSize] = useState(10);
  const [titleColor, setTitleColor] = useState('#808080');
  const [showLogoOnCover, setShowLogoOnCover] = useState(true);
  const [showAnalyticInput, setShowAnalyticInput] = useState(false);
  const [selectedPagesAnalytic, setSelectedPagesAnalytic] = useState([]);
  const [analyticReportData, setAnalyticReportData] = useState(null);
  const [isGeneratingAnalytic, setIsGeneratingAnalytic] = useState(false);
  const relatorioAnaliticoRef = useRef();
  const linkClient = process.env.REACT_APP_CLIENT_URL;
  const [isLoadingPDF, setIsLoadingPDF] = useState(false);
  const [downloadSuccessMessage, setDownloadSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [analyticReportId, setAnalyticReportId] = useState(null);
  const [shouldShowReport, setShouldShowReport] = useState(false);
  const [fileFormat, setFileFormat] = useState("xlsx");
  const [summaryType, setSummaryType] = useState('resumido');
  const [showTermsSummary, setShowTermsSummary] = useState(false);
  const [printedMode, setPrintedMode] = useState('image');

  const pageOptions = [
        { value: 'all', label: 'Todos' },
        { value: 'sumary', label: 'Resumo' },
        { value: 'qualitativeAnalysis', label: 'Análise qualitativa das matérias' },
        { value: 'textType', label: 'Notícias por tipo de texto' },
        { value: 'directIndirect', label: 'Direta/Indireta' },
        { value: 'releaseMention', label: 'Origem da Pauta' },
        { value: 'topicWordCloud', label: 'Nuvem de Assuntos' },
        { value: 'mediaDistribution', label: 'Distribuição por mídia' },
        { value: 'occupiedSpace', label: 'Espaço ocupado na mídia' },
        { value: 'qualitativeSpace', label: 'Análise qualitativa do espaço' },
        { value: 'categoriesTotal', label: 'Total por Categoria' },
        { value: 'categoriesQualitative', label: 'Análise Qualitativa por Categoria' },
        { value: 'mediaNews', label: 'Notícias por veículo' },
        { value: 'mediaValue', label: 'Valoração por veículo' },
        { value: 'top10SourcesClippingValuation', label: 'Top 10 Valoração Por Veículo' },
        { value: 'publishDate', label: 'Notícias por data de publicação' },
        { value: 'statesNews', label: 'Notícias por estado' },
        { value: 'swot', label: 'Análise SWOT' },
        { value: 'audienceAnalysis', label: 'Audiência' },
        { value: 'totalMedia', label: 'Total Mídias' },
        { value: 'vehicles', label: 'Veículos' },
        { value: 'vehicles-tv', label: 'Veículos TV' },
        { value: 'vehicles-radio', label: 'Veículos Rádio' },
        { value: 'vehicles-impresso', label: 'Veículos Impresso' },
        { value: 'vehicles-web', label: 'Veículos Web' },
        { value: 'categories', label: 'Categorias' },
        { value: 'tagsQualitative', label: 'Tabela de Assuntos' },
        { value: 'Final', label: 'Conclusão' },
    ];

      const customStylesPages = {
        control: (provided, state) => ({
            ...provided,
            maxWidth: '100%',
            padding: '10px',
            fontSize: '14px',
            borderColor: state.isFocused ? '#ccc' : '#ccc',
            borderRadius: '4px',
            backgroundColor: 'white',
            color: '#333',
            outline: 'none',
            boxShadow: state.isFocused ? '0 0 0 1px #ccc' : 'none',
            transition: 'border-color 0.3s, box-shadow 0.3s',
            '&:hover': {
                borderColor: '#ccc',
            },
        }),
          valueContainer: (provided) => ({
            ...provided,
            width: '500px',
            maxHeight: '70px',       // altura máxima da área com os valores selecionados
            overflowY: 'auto',        // scroll quando exceder
            flexWrap: 'wrap',         // garante quebra de linha
          }),
        option: (provided, state) => ({
            ...provided,
            maxWidth: '100%',
            backgroundColor: state.isFocused ? '#eee' : '#fff',
            color: '#333',
            padding: '10px',
            '&:active': {
                backgroundColor: '#eee',
            },
        }),
        menu: (provided) => ({
            ...provided,
            maxWidth: '100%',
            zIndex: 2,
        }),
    };

  const handleDownloadReport = async () => {
        setIsLoadingPDF(true); // Ativa o loading no botão de download
        try {
            if (relatorioAnaliticoRef.current) {
                await relatorioAnaliticoRef.current.handlePrint();
                setDownloadSuccessMessage('Relatório exportado com sucesso!');
            }
        } catch (error) {
            console.error(error);
            setErrorMessage('Erro ao fazer o download do relatório.');
        } finally {
            setIsLoadingPDF(false); // Desativa o loading
        }

        // Limpa mensagens após 5 segundos
        setTimeout(() => {
            clearMessages();
        }, 3000);
    };

      const clearMessages = () => {
        setSuccessMessage('');
        setErrorMessage('');
        setDownloadSuccessMessage('');
    };

const handlePageSelectionAnalytic = (selected) => {
  if (selected.some(option => option.value === 'all')) {
    setSelectedPagesAnalytic(pageOptions.filter(option => option.value !== 'all'));
  } else {
    setSelectedPagesAnalytic(selected);
  }
};

const handleSavePDF = async () => {
  if (!relatorioAnaliticoRef.current || !pdfTitle || !analyticReportId) return;

  try {
    setIsLoadingPDF(true);

    const pdfBlob = await relatorioAnaliticoRef.current.generatePDFBlob();
    if (!pdfBlob) throw new Error("PDF não foi gerado corretamente");

    await patchAnalyticalReportData(analyticReportId, pdfTitle, pdfBlob);

    setSuccessMessage("PDF salvo com sucesso!");
  } catch (err) {
    console.error("Erro ao salvar PDF:", err);
    setError("Erro ao salvar PDF. Tente novamente.");
  } finally {
    setIsLoadingPDF(false);
    setTimeout(() => {
      setError('');
      setSuccessMessage('');
    }, 5000);
  }
};

const handleVisualizarRelatorio = async (id) => {
  try {
    const details = await getAnalyticalReportDataDetails(id);
    if (details?.results) {
      setAnalyticReportData(details.results);
      setShouldShowReport(true);
      setSuccessMessage("Relatório carregado com sucesso!");
      setTimeout(() => setSuccessMessage(''), 5000);
    }
  } catch (error) {
    console.error("Erro ao carregar relatório analítico:", error);
    setError("Erro ao carregar relatório analítico.");
    setTimeout(() => setError(''), 5000);
  }
};

const handleGenerateAnalyticReport = async () => {

  if (selectedCards.length === 0) {
    setError('Nenhum clipping selecionado.');
    setTimeout(() => setError(''), 4000);
    return;
  }

  setIsGeneratingAnalytic(true);

  try {
    const response = await postAnalyticalReportDataByClippingIds(clientId, selectedCards);

    if (!response?.id) throw new Error("Resposta da API não contém ID");

    const details = await getAnalyticalReportDataDetails(response.id);
    setAnalyticReportId(response.id);

    if (details.count === 0 || details.total === 0) {
      setError('Não há notícias avaliadas para os clippings selecionados.');
    } else {
      setAnalyticReportData(details.results);
      setSuccessMessage('Relatório gerado com sucesso!');
    }

    setTimeout(() => {
      setSuccessMessage('');
    }, 5000);
  } catch (error) {
    console.error('Erro ao gerar relatório analítico:', error);
    setError('Erro ao gerar relatório analítico.');
    setTimeout(() => setError(''), 5000);
  } finally {
    setIsGeneratingAnalytic(false);
  }
};


  const handleExcelClick = () => {
    setShowEmailInput(true);
    setShowPdfInput(false);
  };

  const handlePdfClick = () => {
    setShowPdfInput(true);
    setShowEmailInput(false);
  };

  const handleGenerateExcel = () => {
    if (selectedCards.length > 150 && !validateEmail(email)) {
        setError('Por favor, insira um e-mail válido.');
        setTimeout(() => setError(''), 4000);
        return;
    }

    const emailToSend = selectedCards.length > 150 ? email : '';
    onExportExcel(emailToSend, fileFormat);
    onClose();
};

  const handleGeneratePDF = () => {
    const title = pdfTitle;
    const subtitle = pdfSubtitle;

    onExportPDF(
      title,
      subtitle,
      sortOption,
      includeTitleAndSubtitle,
      includeSummary,
      logoPosition,
      titleFontSize,
      subtitleFontSize,
      titleColor,
      showLogoOnCover,
      summaryType,
      showTermsSummary,
      printedMode
    );
    onClose();
  };

  const handleSendNewsletter = async () => {
    if (!validateEmail(newsletterEmail)) {
        setError('Por favor, insira um e-mail válido.');
        setTimeout(() => setError(''), 4000);
        return;
    }

    setIsLoading(true);

    try {
        await sendNewsletterWithClippings({
            clientId,
            email: newsletterEmail,
            clippings: selectedCards,
            newsletter: newsletterId,
        });

        setSuccessMessage('Newsletter enviada com sucesso!');
        setNewsletterEmail('');

        setTimeout(() => setSuccessMessage(''), 5000);
    } catch (error) {
        setError('Erro ao enviar a newsletter. Tente novamente.');
        setTimeout(() => setError(''), 5000);
        console.error("Erro ao enviar newsletter:", error);
    } finally {
        setIsLoading(false);
    }
};

  const handleNewsletterClick = async () => {
    setShowNewsletterInput(true);
    setShowEmailInput(false);
    setShowPdfInput(false);
    setNewsletterId(null);
  
    if (!clientId) {
      setError('Erro: Client ID não encontrado.');
      setTimeout(() => setError(''), 5000);
      return;
    }
  
    try {
      console.log(`Buscando newsletter para Client ID: ${clientId}`);
      const response = await fetchClientNewsletterPreview(clientId);
  
      if (!response || !response.newsletter_id) {
        throw new Error('Erro ao obter o ID da newsletter.');
      }
  
      const baseUrl = `${process.env.REACT_APP_LINK_URL}pt-br/newsletter/newsletter`;
      const newsletterId = response.newsletter_id;
      setNewsletterId(newsletterId);
      const selectedNewsIds = selectedCards.join(",");
  
      const constructedUrl = `${baseUrl}/${clientId}/${newsletterId}/preview/publico/?news_ids=${selectedNewsIds}`;
      
      console.log("URL do iframe gerada:", constructedUrl);
      
      setIframeUrl(constructedUrl);
      setTemplate(response.template);

    } catch (error) {
      console.error("Erro ao buscar newsletter:", error);
      setError('Erro ao carregar prévia da newsletter.');
      setTimeout(() => setError(''), 5000);
    }
  };
  
  

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" style={showAnalyticInput ? { minWidth: '1200px', minHeight: '600px' } : {}} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Exportar</h2>
          <button className="close-button" onClick={onClose}>
            <FaTimes />
          </button>
        </div>
        <div className="modal-body">
          {!showEmailInput && !showPdfInput && !showNewsletterInput && !showAnalyticInput ? (
            <>
              <button
                className="export-button"
                onClick={() => {
                  setShowEmailInput(true);
                  setShowPdfInput(false);
                  setShowNewsletterInput(false);
                  setShowAnalyticInput(false);
                }}
              >
                <FaFileExcel className="icon" />
                <span>Exportar Planilha</span>
              </button>
              <button className="export-button" onClick={handlePdfClick}>
                <FaFilePdf className="icon" />
                <span>Exportar PDF</span>
              </button>
              <button className="export-button" onClick={handleNewsletterClick}>
                <FaNewspaper className="icon" />
                <span>Newsletter</span>
              </button>
              <button
                className="export-button"
                onClick={async () => {
                  setShowAnalyticInput(true);
                  setShowEmailInput(false);
                  setShowPdfInput(false);
                  setShowNewsletterInput(false);
                  await handleGenerateAnalyticReport();
                }}
              >
                <FaFilePdf className="icon" />
                <span>Relatório Analítico</span>
              </button>
            </>
          ) : showEmailInput ? (
            <div className="email-input-section">
              <div className="container-export-excel">
                {selectedCards.length > 150 && (
                  <div className="filter-email-export-excel">
                    <div className="filter-email-export-excel-text">E-mail para envio</div>
                    <input
                      type="email"
                      id="email"
                      placeholder="Digite o e-mail para envio da planilha"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="email-input-export-excel"
                    />
                  </div>
                )}
              </div>

              <div className="summary-add-export-pdf" style={{ marginTop: 12, width: '500px',}}>
                <h4 className="sort-title-export-pdf">Formato do arquivo</h4>

                <label className="custom-checkbox-export-pdf" style={{ marginRight: 16 }}>
                  <input
                    type="radio"
                    name="fileFormat"
                    value="xlsx"
                    checked={fileFormat === "xlsx"}
                    onChange={(e) => setFileFormat(e.target.value)}
                  />
                  <span className="checkmark-export-pdf"></span>
                  XLSX (Excel)
                </label>

                <label className="custom-checkbox-export-pdf">
                  <input
                    type="radio"
                    name="fileFormat"
                    value="csv"
                    checked={fileFormat === "csv"}
                    onChange={(e) => setFileFormat(e.target.value)}
                  />
                  <span className="checkmark-export-pdf"></span>
                  CSV
                </label>
              </div>

              <div className='container-button-export-excel'>
                <button className="generate-button-export-excel" onClick={handleGenerateExcel}>
                  Gerar planilha
                </button>
              </div>
            </div>
          ) : showPdfInput ? (
            <div className="pdf-input-section">

              <label className="custom-checkbox-export-pdf title-and-subtitle">
                <input
                  type="checkbox"
                  checked={includeTitleAndSubtitle}
                  onChange={(e) => setIncludeTitleAndSubtitle(e.target.checked)}
                />
                <span className="checkmark-export-pdf"></span>
                Adicionar título e subtítulo
              </label>
              
              {includeTitleAndSubtitle && (
                <>
                  <div className="container-export-excel">
                    <div className="filter-email-export-excel">
                      <div className="filter-email-export-excel-text">Título do PDF:</div>
                      <input
                          type="text"
                          id="pdfTitle"
                          placeholder="Digite o título"
                          value={pdfTitle}
                          onChange={(e) => setPdfTitle(e.target.value)}
                          className="email-input-export-excel"
                      />
                    </div>
                  </div>

                  <div className="container-export-excel">
                    <div className="filter-email-export-excel">
                      <div className="filter-email-export-excel-text">Subtítulo do PDF:</div>
                      <textarea
                          type="text"
                          id="pdfSubtitle"
                          placeholder="Digite o subtítulo"
                          value={pdfSubtitle}
                          onChange={(e) => setPdfSubtitle(e.target.value)}
                          className="email-input-export-excel"
                      />
                    </div>
                  </div>
                  </>
                )}
                <div className="summary-add-export-pdf">
                  <h4 className="sort-title-export-pdf">sumário:</h4>
                    <label className="custom-checkbox-export-pdf title-and-subtitle">
                      <input
                        type="checkbox"
                        checked={includeSummary}
                        onChange={(e) => setIncludeSummary(e.target.checked)}
                      />
                      <span className="checkmark-export-pdf"></span>
                      Incluir Sumário
                    </label>
                </div>
                {includeSummary && (
                  <div className="summary-add-export-pdf">
                    <h4 className="sort-title-export-pdf">Tipo de Sumário:</h4>
                    <label className="custom-checkbox-export-pdf">
                      <input
                        type="radio"
                        name="summaryType"
                        value="resumido"
                        checked={summaryType === 'resumido'}
                        onChange={(e) => setSummaryType(e.target.value)}
                      />
                      <span className="checkmark-export-pdf"></span>
                      Resumido
                    </label>
                    <label className="custom-checkbox-export-pdf">
                      <input
                        type="radio"
                        name="summaryType"
                        value="detalhado"
                        checked={summaryType === 'detalhado'}
                        onChange={(e) => setSummaryType(e.target.value)}
                      />
                      <span className="checkmark-export-pdf"></span>
                      Detalhado
                    </label>
                  </div>
                )}
                <div className="custom-select-group">
                  <div className="container-export-excel">
                    <div className="summary-add-export-pdf">
                      <h4 className="sort-title-export-pdf">Logo:</h4>
                      <label className="custom-checkbox-export-pdf">
                        <input
                          type="checkbox"
                          checked={showLogoOnCover}
                          onChange={(e) => setShowLogoOnCover(e.target.checked)}
                        />
                        <span className="checkmark-export-pdf"></span>
                        Mostrar logo
                      </label>
                    </div>

                    <div className="summary-add-export-pdf">
                      <h4 className="sort-title-export-pdf">Posição Logo:</h4>
                      <label className="custom-checkbox-export-pdf">
                        <input
                          type="radio"
                          name="logoPosition"
                          value="default"
                          checked={logoPosition === 'default'}
                          onChange={(e) => setLogoPosition(e.target.value)}
                        />
                        <span className="checkmark-export-pdf"></span>
                        Original
                      </label>
                      <label className="custom-checkbox-export-pdf">
                        <input
                          type="radio"
                          name="logoPosition"
                          value="center"
                          checked={logoPosition === 'center'}
                          onChange={(e) => setLogoPosition(e.target.value)}
                        />
                        <span className="checkmark-export-pdf"></span>
                        Centralizado
                      </label>
                    </div>
                    <div className="summary-add-export-pdf">
                    <h4 className="sort-title-export-pdf">Estilo Capa:</h4>
                    </div>
                    <div className="filter-email-export-excel">
                      <div className="filter-email-export-excel-text">Tamanho da fonte do título:</div>
                      <input
                        type="number"
                        min="8"
                        max="19"
                        value={titleFontSize}
                        onChange={(e) => setTitleFontSize(Number(e.target.value))}
                        className="email-input-export-excel"
                        placeholder="Ex: 20"
                      />
                    </div>

                    <div className="filter-email-export-excel">
                      <div className="filter-email-export-excel-text">Tamanho da fonte do subtítulo:</div>
                      <input
                        type="number"
                        min="8"
                        max="18"
                        value={subtitleFontSize}
                        onChange={(e) => setSubtitleFontSize(Number(e.target.value))}
                        className="email-input-export-excel"
                        placeholder="Ex: 14"
                      />
                    </div>

                    <div className="filter-email-export-excel">
                      <div className="filter-email-export-excel-text">Cor do título e subtítulo:</div>
                      <input
                        type="color"
                        value={titleColor}
                        onChange={(e) => setTitleColor(e.target.value)}
                        className="email-input-export-excel"
                        style={{ width: '100%', height: '50px', padding: '6px', border: '1px solid #ccc', borderRadius: '5px', backgroundColor: 'white' }}
                      />
                    </div>
                </div>

              </div>
                <div className="sort-options-export-pdf">
                  <h4 className="sort-title-export-pdf">Ordenar por:</h4>
                    <label className="custom-checkbox-export-pdf">
                      <input
                        type="radio"
                        name="sortOption"
                        value="veiculo"
                        checked={sortOption === 'veiculo'}
                        onChange={(e) => setSortOption(e.target.value)}
                      />
                      <span className="checkmark-export-pdf"></span>
                      Veículo
                    </label>
                    <label className="custom-checkbox-export-pdf">
                      <input
                        type="radio"
                        name="sortOption"
                        value="dataRecente"
                        checked={sortOption === 'dataRecente'}
                        onChange={(e) => setSortOption(e.target.value)}
                      />
                      <span className="checkmark-export-pdf"></span>
                      Data Mais Recente
                    </label>
                    <label className="custom-checkbox-export-pdf">
                      <input
                        type="radio"
                        name="sortOption"
                        value="dataAntiga"
                        checked={sortOption === 'dataAntiga'}
                        onChange={(e) => setSortOption(e.target.value)}
                      />
                      <span className="checkmark-export-pdf"></span>
                      Data Mais Antiga
                    </label>
                    <label className="custom-checkbox-export-pdf">
                      <input
                        type="radio"
                        name="sortOption"
                        value="selecionada"
                        checked={sortOption === 'selecionada'}
                        onChange={(e) => setSortOption(e.target.value)}
                      />
                      <span className="checkmark-export-pdf"></span>
                      Ordem Selecionada
                    </label>
                  </div>

                  <div className="summary-add-export-pdf">
                    <h4 className="sort-title-export-pdf">Conteúdo para IMPRESSO:</h4>
                    <label className="custom-checkbox-export-pdf" style={{ marginRight: 16 }}>
                      <input
                        type="radio"
                        name="printedMode"
                        value="image"
                        checked={printedMode === 'image'}
                        onChange={(e) => setPrintedMode(e.target.value)}
                      />
                      <span className="checkmark-export-pdf"></span>
                      imagem
                    </label>

                    <label className="custom-checkbox-export-pdf" style={{ marginRight: 16 }}>
                      <input
                        type="radio"
                        name="printedMode"
                        value="image+text"
                        checked={printedMode === 'image+text'}
                        onChange={(e) => setPrintedMode(e.target.value)}
                      />
                      <span className="checkmark-export-pdf"></span>
                      Imagem + texto
                    </label>

                    <label className="custom-checkbox-export-pdf">
                      <input
                        type="radio"
                        name="printedMode"
                        value="text"
                        checked={printedMode === 'text'}
                        onChange={(e) => setPrintedMode(e.target.value)}
                      />
                      <span className="checkmark-export-pdf"></span>
                      texto
                    </label>
                  </div>

                  <div className="summary-add-export-pdf">
                    <h4 className="sort-title-export-pdf">RESUMO DOS TERMOS:</h4>
                    <label className="custom-checkbox-export-pdf title-and-subtitle">
                      <input
                        type="checkbox"
                        checked={showTermsSummary}
                        onChange={(e) => setShowTermsSummary(e.target.checked)}
                      />
                    <span className="checkmark-export-pdf"></span>
                      Incluir
                    </label>
                  </div>

                <div className='container-button-export-excel'>
                  <button className="generate-button-export-excel" onClick={handleGeneratePDF}>
                      Gerar PDF
                  </button>
                </div>
            </div>
          ): showNewsletterInput ? (
            <div className='newsletter-input-section-container'>
              {template && !template.endsWith('newsletter-wpp.html') && (
                <div className="newsletter-input-section">
                  <div className="container-export-excel">
                    <div className="filter-email-export-excel">
                      <div className="filter-email-export-excel-text">E-mail para envio</div>
                      <input
                          type="email"
                          id="newsletterEmail"
                          placeholder="Digite o e-mail para envio da Newsletter"
                          value={newsletterEmail}
                          onChange={(e) => setNewsletterEmail(e.target.value)}
                          className="email-input-export-excel"
                      />
                    </div>
                  </div>
                  <div className='container-button-export-newsletter'>
                    <button className="generate-button-export-newsletter" onClick={handleSendNewsletter}>
                      Enviar Newsletter
                    </button>
                  </div>
                </div>
              )}
              {iframeUrl ? (
                <div className="iframe-container">
                  <iframe
                    src={iframeUrl}
                    width="1000px"
                    height="500px"
                    style={{ border: "1px solid #ccc", marginTop: "20px", marginBottom: "20px" }}
                    title="Prévia da Newsletter"
                  />
                </div>
              ) : null}
            </div>
          ) : showAnalyticInput ? (
            <div className="analytic-container">
              <div className="analytic-input-section">
                {analyticReportId && (
                  <RelatorioStatusCard
                    reportId={analyticReportId}
                    onVisualizar={handleVisualizarRelatorio}
                  />
                )}
                {analyticReportData && shouldShowReport === true && (
                  <>
                    <div className="row-pdf-save">
                      <div className="filter-pdf-save">
                        <div className="filter-label-relatorio">Nome do PDF</div>
                        <input
                          type="text"
                          className="filter-select-relatorio keyword-dropdown"
                          placeholder="Digite o nome do PDF"
                          value={pdfTitle}
                          onChange={(e) => setPdfTitle(e.target.value)}
                        />
                      </div>
                      <div className="filter-tela-relatorio">
                        <div className="filter-label-relatorio" style={{ visibility: 'hidden' }}>.</div>
                        <button
                          className="buttonGeneratePdfSave"
                          onClick={handleSavePDF}
                          disabled={isLoadingPDF || !pdfTitle}
                        >
                          {isLoadingPDF ? 'Salvando...' : 'Salvar PDF'}
                        </button>
                      </div>
                    </div>
                  </>
                )}
                {analyticReportData && shouldShowReport === true &&(
                  <div className="filter-tela-relatorio" style={{ margin: '20px 0' }}>
                    <div className="filter-label-relatorio">Páginas</div>
                    <Select
                      className="filter-select-relatorio"
                      styles={customStylesPages}
                      placeholder="Selecione as páginas"
                      isMulti
                      value={selectedPagesAnalytic}
                      onChange={handlePageSelectionAnalytic}
                      options={pageOptions}
                    />
                  </div>
                )}
                {isGeneratingAnalytic && (
                  <div className="loading-overlay active">
                    <ReactLoading type={'spin'} color={'#121926'} height={80} width={80} />
                  </div>
                )}
              </div>

              {analyticReportData && shouldShowReport === true &&(
                <div className="preview-container">
                  <div className="preview-header">
                    <h2>Relatório Analítico Gerado:</h2>
                    <button className="download-button" onClick={handleDownloadReport} disabled={isLoadingPDF}>
                      <FaDownload /> Download
                    </button>
                  </div>
                  <RelatorioAnalitico
                    ref={relatorioAnaliticoRef}
                    reportData={analyticReportData}
                    selectedPages={selectedPagesAnalytic}
                    clientId={clientId}
                    isLoadingPDF={isLoadingPDF}
                    reportFinalImage={
                      analyticReportData?.images?.report_final_image
                        ? analyticReportData.images.report_final_image.replace(process.env.REACT_APP_AWS_URL, `${linkClient}`)
                        : null
                    }
                    reportInitialimage={
                      analyticReportData?.images?.report_cover_image
                        ? analyticReportData.images.report_cover_image.replace(process.env.REACT_APP_AWS_URL, `${linkClient}`)
                        : `${linkClient}/media/reports/fundo-inicial-relatorio.png`
                    }
                    reportGrapichImage={
                      analyticReportData?.images?.report_charts_image
                        ? analyticReportData.images.report_charts_image.replace(process.env.REACT_APP_AWS_URL, `${linkClient}`)
                        : `${linkClient}/media/reports/fundo-graficos-relatorio.png`
                    }
                    reportInfoImage={
                      analyticReportData?.images?.report_info_image
                        ? analyticReportData.images.report_info_image.replace(process.env.REACT_APP_AWS_URL, `${linkClient}`)
                        : `${linkClient}/media/reports/fundo-informacoes.png`
                    }
                  />
                </div>
              )}
            </div>
          ) : null}
        </div>
      </div>
      {error && <div className="error-message">{error}</div>}
      {successMessage && <div className="success-message">{successMessage}</div>}
      {isLoading && (
        <div className={isLoading ? 'loading-overlay active' : 'loading-overlay'}>
          <ReactLoading type={'spin'} color={'#121926'} height={80} width={80} />
        </div>
      )}
      {isLoadingPDF && (
        <div className="loading-overlay active">
          <ReactLoading type={'spin'} color={'#121926'} height={80} width={80} />
        </div>
      )}
    </div>
  );
}

export default ExportModal;
